<template>
  <div>
    <h2 class="transfer-detail__title">应收账款转让通知书详情</h2>
    <div class="transfer-detail__content">
      <!-- 导航栏 -->
      <el-radio-group v-model="pdfTabShow"
                      style="margin-bottom: 30px;">
        <!-- 确认来源:前台确认,确认状态为:已确认, 显示转让通知书回执回执 -->
        <el-radio-button class="transfer-detail__pdf-tab"
                         v-if="adviceDetail.adviceConfirmSource === '1' && adviceDetail.adviceState === '1'"
                         label="1">转让通知书回执</el-radio-button>
        <el-radio-button class="transfer-detail__pdf-tab"
                         label="2">转让通知书</el-radio-button>
      </el-radio-group>
      <!-- PDF -->
      <div class="transfer-detail__pdfs">
        <iframe class="transfer-detail__pdf"
                v-show="pdfTabShow==1"
                :src="deliveryPdfUrl"></iframe>
        <iframe class="transfer-detail__pdf"
                v-show="pdfTabShow==2"
                :src="advicePdfUrl"></iframe>
      </div>
      <div class="transfer-detail__bottom">
        <el-button type="primary"
                   class="transfer-detail__back-btn"
                   @click="goBack()">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '../../vuex/types';
import { mapGetters } from 'vuex';
import api from '../../api/transferAdvice.js';
export default {
  name: 'TransferAdviceDetail',
  data () {
    return {
      pdfTabShow: '2',
      adviceDetail: {
        adviceId: 0,
        adviceConfirmSource: null,
        adviceState: null
      }
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL
    }),
    pdfPath () {
      return './static/js/pdf/web/viewer.html?file=';
    },
    advicePdfUrl () {
      const url = `${this.ajaxBaseUrl}/crmform/buyer/front/readTransferAdvicePdf.ht?adviceId=${this.adviceDetail.adviceId}`;
      return this.pdfPath + encodeURIComponent(url);
    },
    deliveryPdfUrl () {
      const url = `${this.ajaxBaseUrl}/crmform/buyer/front/readTransferDeliveryPdf.ht?adviceId=${this.adviceDetail.adviceId}`;
      return this.pdfPath + encodeURIComponent(url);
    }
  },
  methods: {
    getData (id) {
      const that = this;
      api.getTransferAdviceDetail(id).then((resp) => {
        const respData = resp.data;
        if (respData.rspcode === 1) {
          that.adviceDetail = respData.data;
        }
      });
    },
    goBack () {
      this.$router.push('/personalCenter/transferAdvice/list');
    }
  },
  mounted () {
    const id = this.$route.params.id;
    this.getData(id);
  }
};
</script>

<style>
.transfer-detail__content {
  box-sizing: border-box;
  background-color: #fff;
  width: 900px;
  box-sizing: border-box;
  margin-left: 20px;
  padding: 30px 22px 50px 22px;
}

.transfer-detail__title {
  font-size: 22px;
  font-weight: bolder;
  height: 60px;
  line-height: 60px;
  margin-left: 20px;
}

.transfer-detail__pdf {
  width: 850px;
  height: 520px;
}

.transfer-detail__bottom {
  margin-top: 35px;
  text-align: center;
  width: 850px;
}

.transfer-detail__back-btn {
  width: 90px;
  height: 40px;
}

.transfer-detail__pdf-tab .el-radio-button__inner {
  width: 120px;
  height: 38px;
  padding: 10px;
}
</style>




// WEBPACK FOOTER //
// TransferAdviceDetail.vue?0c989590